class Megamenu {
  constructor(container) {
    this.selectors = {
      announcementBar: ".m-announcement-bar",
      hamburgerButtons: ".m-hamburger-box",
      desktopMenuItems: [".m-menu__item"],
      desktopSubMenus: ".m-mega-menu",
      headerMobile: ".m-header__mobile",
      menuDrawer: "#m-menu-drawer",
      menuDrawerContent: ".m-menu-drawer__content",
      menu: ".m-menu-mobile",
      menuItems: [".m-menu-mobile__item"],
      megaMenuMobile: [".m-megamenu-mobile"],
      backDrop: ".m-menu-drawer__backdrop",
    };
    this.menuSelectors = {
      subMenu: ".m-mega-menu",
    };
    this.activeDesktopMenuItem = null;

    this.sliders = {};
    this.open = false;
    this.container = container;
    this.transitionDuration = 0;
    this.domNodes = queryDomNodes(this.selectors);
    this.menuData = [...this.domNodes.desktopMenuItems].map((item) => {
      const header = item.closest("header");
      const menuNodes = queryDomNodes(this.menuSelectors, item);
      return { header, item, ...menuNodes, active: false };
    });
    this.init();

    MinimogTheme = MinimogTheme || {};
    MinimogTheme.headerSliders = this.sliders;
  }

  init() {
    this.domNodes.hamburgerButtons.addEventListener("click", (e) => {
      if (this.domNodes.hamburgerButtons.classList.contains("active")) {
        this.closeMenu();
      } else {
        this.openMenu();
      }
      this.domNodes.hamburgerButtons.classList.toggle("active");
    });
    this.domNodes.backDrop.addEventListener("click", (e) => {
      this.closeMenu();
    });
    this.initMobileMegaMenu();
    this.initDesktopMegaMenu();

    MinimogEvents.subscribe(MinimogTheme.pubSubEvents.openCartDrawer, () => {
      this.open && this.closeMenu();
    });
    MinimogEvents.subscribe(MinimogTheme.pubSubEvents.openSearchPopup, () => {
      this.open && this.closeMenu();
    });
  }
  initDesktopMegaMenu() {
    [...this.menuData].forEach((menuItem) => {
      const { item, subMenu } = menuItem;
      if (subMenu) {
        this.initDesktopMenuButton(item, subMenu);
        const productsBanner = subMenu.querySelector(".m-mega-product-list");
        if (productsBanner) {
          if (window && window.__sfWindowLoaded) {
            menuItem.productsBannerSlider = this.initProductsBanner(productsBanner);
          } else {
            window.addEventListener("load", () => {
              menuItem.productsBannerSlider = this.initProductsBanner(productsBanner);
            });
          }
        }
        this.initDesktopMegaMenuPanels(subMenu);
      }
    });
  }
  initDesktopMenuButton(item, subMenu) {
    const button = item.querySelector(".m-menu__link--main[type='button']");

    if (!button || button.dataset.megaMenuButtonBound === "true") return;

    const setExpanded = (expanded) => {
      button.setAttribute("aria-expanded", expanded ? "true" : "false");
    };
    const closeSiblings = () => {
      const menu = item.closest(".m-menu");
      if (!menu) return;

      [...menu.querySelectorAll(".m-menu__item--active")].forEach((menuItem) => {
        if (menuItem === item) return;

        menuItem.classList.remove("m-menu__item--active");
        const toggle = menuItem.querySelector(".m-menu__link--main[aria-expanded]");
        toggle && toggle.setAttribute("aria-expanded", "false");

        if (document.activeElement && menuItem.contains(document.activeElement)) {
          document.activeElement.blur();
        }
      });
    };

    button.addEventListener("click", () => {
      closeSiblings();
      item.classList.add("m-menu__item--active");
      setExpanded(true);
      button.focus();
    });

    item.addEventListener("mouseenter", () => {
      closeSiblings();
      setExpanded(true);
    });
    item.addEventListener("mouseleave", () => {
      window.setTimeout(() => {
        if (!item.matches(":hover") && !item.contains(document.activeElement)) {
          setExpanded(false);
        }
      }, 250);
    });
    item.addEventListener("focusin", () => {
      closeSiblings();
      item.classList.add("m-menu__item--active");
      setExpanded(true);
    });
    item.addEventListener("focusout", () => {
      window.setTimeout(() => {
        if (!item.contains(document.activeElement)) {
          item.classList.remove("m-menu__item--active");
          setExpanded(false);
        }
      });
    });

    button.dataset.megaMenuButtonBound = "true";
  }
  initDesktopMegaMenuPanels(subMenu) {
    if (!subMenu.classList.contains("m-mega-menu--new")) return;

    const triggers = [...subMenu.querySelectorAll("[data-mega-menu-trigger]")];
    const panels = [...subMenu.querySelectorAll("[data-mega-menu-panel]")];

    if (!triggers.length || !panels.length) return;

    const activatePanel = (trigger) => {
      const panelId = trigger.getAttribute("aria-controls");
      const panel = panelId && subMenu.querySelector(`#${CSS.escape(panelId)}`);

      if (!panel) return;

      triggers.forEach((item) => {
        const isActive = item === trigger;
        item.classList.toggle("is-active", isActive);
        item.setAttribute("aria-selected", isActive ? "true" : "false");
      });

      panels.forEach((item) => {
        const isActive = item === panel;
        item.classList.toggle("is-active", isActive);
        item.hidden = !isActive;
      });
    };

    triggers.forEach((trigger) => {
      if (trigger.dataset.megaMenuTriggerBound === "true") return;
      trigger.addEventListener("mouseenter", () => activatePanel(trigger));
      trigger.addEventListener("focus", () => activatePanel(trigger));
      trigger.addEventListener("click", (event) => {
        event.preventDefault();
        activatePanel(trigger);
      });
      trigger.dataset.megaMenuTriggerBound = "true";
    });

    if (!triggers.some((trigger) => trigger.classList.contains("is-active"))) {
      activatePanel(triggers[0]);
    }
  }
  closeDesktopSubmenu = (menuItemIndex) => {
    const menuItem = this.menuData[menuItemIndex];
    const { header } = menuItem;
    header && header.classList.remove("show-menu");
  };
  initProductsBanner(banner) {
    const header = banner.closest("header");
    const menuItem = banner.closest(".m-menu__item");
    const screenClass = (header && `.${header.dataset.screen}`) || "";

    const id = banner.dataset.id;
    const sliderContainer = document.querySelector(`.m-product-list-${id}`);
    const columns = sliderContainer.dataset.column;

    let slider;
    slider = new MinimogLibs.Swiper(`${screenClass} .m-product-list-${id}`, {
      slidesPerView: 1,
      loop: false,
      autoplay: false,
      breakpoints: {
        1200: { slidesPerView: columns },
        992: { slidesPerView: columns >= 2 ? 2 : columns },
      },
    });
    this.sliders[menuItem.dataset.index] = slider;

    if (slider) {
      const prevBtn = document.querySelector(`#m-slider-controls-${id} .m-slider-controls__button-prev`);
      const nextBtn = document.querySelector(`#m-slider-controls-${id} .m-slider-controls__button-next`);
      prevBtn && prevBtn.addEventListener("click", () => slider.slidePrev());
      nextBtn && nextBtn.addEventListener("click", () => slider.slideNext());
    }
  }

  initMobileMegaMenu() {
    this.initMobileDrawerAccordions();

    [...this.domNodes.menuItems].forEach((item) => {
      const subMenuContainer = item.querySelector(".m-megamenu-mobile");
      const backBtn = item.querySelector(".m-menu-mobile__back-button");

      if (subMenuContainer) {
        addEventDelegate({
          context: item,
          selector: "[data-toggle-submenu]",
          handler: (e, target) => {
            e.preventDefault();
            const level = target.dataset.toggleSubmenu;
            const parentNode = e.target.parentNode;
            if (
              e.target.classList.contains("m-menu-mobile__back-button") ||
              parentNode.classList.contains("m-menu-mobile__back-button")
            ) {
              return;
            }

            this.openSubMenu(subMenuContainer, level);
          },
        });
      }

      if (backBtn) {
        addEventDelegate({
          context: item,
          selector: "[data-toggle-submenu]",
          handler: (e, target) => {
            e.preventDefault();
            const level = target.dataset.toggleSubmenu;
            const parentNode = e.target.parentNode;
            if (
              e.target.classList.contains("m-menu-mobile__back-button") ||
              parentNode.classList.contains("m-menu-mobile__back-button")
            ) {
              return;
            }

            this.openSubMenu(subMenuContainer, level);
          },
        });
        backBtn.addEventListener("click", (e) => {
          const level = e.target.dataset.level;
          this.closeSubMenu(subMenuContainer, level);
        });
      }
    });

    document.addEventListener("matchMobile", () => this.setMenuHeight());
    document.addEventListener("unmatchMobile", () => this.setMenuHeight());
    this.menuViewportResizeHandler = () => this.setMenuHeight();
    window.addEventListener("resize", this.menuViewportResizeHandler, { passive: true });
    window.addEventListener("orientationchange", this.menuViewportResizeHandler);
    window.visualViewport && window.visualViewport.addEventListener("resize", this.menuViewportResizeHandler);
  }

  initMobileDrawerAccordions() {
    const { menuDrawer } = this.domNodes;

    if (!menuDrawer || !menuDrawer.classList.contains("m-menu-drawer--accordion")) return;

    const closeAccordionItem = (item) => {
      item.classList.remove("m-menu-drawer__item--open");
      item.querySelectorAll("[data-menu-drawer-toggle]").forEach((toggle) => {
        toggle.setAttribute("aria-expanded", "false");
      });
      item.querySelectorAll(".m-menu-drawer__panel").forEach((panel) => {
        panel.hidden = true;
      });
      item.querySelectorAll("[data-menu-drawer-item]").forEach((childItem) => {
        childItem.classList.remove("m-menu-drawer__item--open");
      });
    };

    const closeSiblingAccordionItems = (item) => {
      const accordionGroup = item.closest(".m-menu-drawer__list, .m-menu-mobile");

      if (!accordionGroup) return;

      [...accordionGroup.children].forEach((sibling) => {
        if (sibling !== item && sibling.matches("[data-menu-drawer-item]")) {
          closeAccordionItem(sibling);
        }
      });
    };

    addEventDelegate({
      context: menuDrawer,
      selector: "[data-menu-drawer-toggle]",
      handler: (e, target) => {
        e.preventDefault();
        e.stopPropagation();

        const item = target.closest("[data-menu-drawer-item]");
        const panel = document.getElementById(target.getAttribute("aria-controls"));
        const isOpen = target.getAttribute("aria-expanded") === "true";

        if (!item || !panel) return;

        closeSiblingAccordionItems(item);

        if (isOpen) {
          closeAccordionItem(item);
          return;
        }

        target.setAttribute("aria-expanded", "true");
        panel.hidden = false;
        item.classList.add("m-menu-drawer__item--open");
      },
    });
  }

  //////////////// MOBILE MENU EVENTS
  openMenu() {
    this.setMenuHeight();
    document.documentElement.classList.add("prevent-scroll");
    this.domNodes.menuDrawer.classList.add("open");
    this.domNodes.headerMobile.classList.add("header-drawer-open");
    this.open = true;
  }

  closeMenu() {
    const { menuDrawer, menu, megaMenuMobile, hamburgerButtons } = this.domNodes;

    setTimeout(() => {
      megaMenuMobile.forEach((container) => {
        container.classList.remove("open");
      });
      menu && menu.classList.remove("m-submenu-open", "m-submenu-open--level-1", "m-submenu-open--level-2");
      menuDrawer.querySelectorAll("[data-menu-drawer-toggle]").forEach((toggle) => {
        const isDefaultOpen = toggle.hasAttribute("data-menu-drawer-default-open");
        toggle.setAttribute("aria-expanded", String(isDefaultOpen));
      });
      menuDrawer.querySelectorAll(".m-menu-drawer__panel").forEach((panel) => {
        panel.hidden = !panel.hasAttribute("data-menu-drawer-default-open");
      });
      menuDrawer.querySelectorAll("[data-menu-drawer-item]").forEach((item) => {
        item.classList.toggle("m-menu-drawer__item--open", item.hasAttribute("data-menu-drawer-default-open"));
      });
      menuDrawer.classList.remove("open");
      document.documentElement.classList.remove("prevent-scroll");
      this.domNodes.headerMobile.classList.remove("header-drawer-open");
      hamburgerButtons.classList.remove("active");
      // Close search
    }, this.transitionDuration);
    this.open = false;
  }

  openSubMenu(subMenuContainer, level) {
    let subMenuOpenClass = `m-submenu-open--level-${level}`;

    this.domNodes.menuDrawerContent.classList.add("open-submenu");
    this.domNodes.menu && this.domNodes.menu.classList.add("m-submenu-open");
    this.domNodes.menu && this.domNodes.menu.classList.add(subMenuOpenClass);
    subMenuContainer.classList.add("open");
  }

  closeSubMenu(subMenuContainer, level) {
    let subMenuOpenClass = `m-submenu-open--level-${level}`;

    level === "1" && this.domNodes.menu && this.domNodes.menu.classList.remove("m-submenu-open");
    this.domNodes.menu && this.domNodes.menu.classList.remove(subMenuOpenClass);
    subMenuContainer.classList.remove("open");
    this.domNodes.menuDrawerContent.classList.remove("open-submenu");
  }

  setMenuHeight() {
    const { menuDrawer, headerMobile } = this.domNodes;
    if (!menuDrawer || !headerMobile) return;

    const offsetBottom = headerMobile.getBoundingClientRect().bottom;
    const viewport = window.visualViewport;
    const viewportBottom = viewport ? viewport.height + viewport.offsetTop : window.innerHeight;
    const panelHeight = Math.max(viewportBottom - offsetBottom, 0);

    menuDrawer.style.setProperty("--menu-drawer-height", `${panelHeight}px`);
  }
}
class SiteNav {
  constructor(container) {
    this.selectors = {
      menuItems: [".m-menu .m-menu__item"],
      dropdowns: [".m-mega-menu"],
      subMenu: ".m-mega-menu",
      overlay: ".m-header__overlay",
      swiper: ".swiper-container",
    };

    this.classes = {
      slideFromRight: "slide-from-right",
      slideReveal: "slide-reveal",
      active: "m-mega-active",
    };

    this.headerSticky = false;

    if (!container) return;
    this.container = container;
    this.domNodes = queryDomNodes(this.selectors, this.container);
    this.activeIndex = -1;
    this.lastActiveIndex = -1;
    this.visited = false;
    this.timeoutEnter = null;
    this.timeoutLeave = null;
    this.lastScrollY = window.scrollY;
    this.attachEvents();
  }

  attachEvents = () => {
    this.domNodes.menuItems.forEach((menuItem, index) => {
      menuItem.addEventListener("mouseenter", (evt) => this.onMenuItemEnter(evt, index));
      menuItem.addEventListener("mouseleave", (evt) => this.onMenuItemLeave(evt, index));
    });
    window.addEventListener("scroll", this.onWindowScroll, { passive: true });
  };

  initDropdownSize = () => {
    this.container && this.container.style.setProperty("--sf-dropdown-width", this.windowWidth());
    this.container && this.container.style.setProperty("--sf-dropdown-height", this.windowHeight());
  };

  onMenuItemEnter = (evt, index) => {
    const { target } = evt;

    if (!target.classList.contains("m-menu__item--mega")) return;

    clearTimeout(this.timeoutLeave);
    this.closeSiblingMegaMenus(target);
    this.activeIndex = target.dataset && Number(target.dataset.index);
    this.headerSticky = this.container && this.container.dataset.sticky === "true";
    this.reInitSlider(target);

    this.container && this.visited
      ? this.container.classList.remove(this.classes.slideReveal)
      : this.container.classList.add(this.classes.slideReveal);

    this.visited = true;
    this.lastActiveIndex >= 0 &&
      this.activeIndex >= 0 &&
      (this.container && this.lastActiveIndex < this.activeIndex
        ? this.container.classList.add(this.classes.slideFromRight)
        : this.lastActiveIndex > this.activeIndex && this.container.classList.remove(this.classes.slideFromRight));

    this.getElementBoundingRect(target).then((rect) => {
      if (rect) {
        this.container && this.container.style.setProperty("--sf-dropdown-width", rect.width);
        this.container && this.container.style.setProperty("--sf-dropdown-height", rect.height);
      }

      this.timeoutEnter = setTimeout(() => {
        if (this.activeIndex !== Number(target.dataset.index)) return;
        this.closeSiblingMegaMenus(target);
        this.container && this.container.classList.add(this.classes.active);
        target.closest(".m-menu__item").classList.add("m-menu__item--active");
        // document.documentElement.classList.add("prevent-scroll");
      }, 120);
    });
  };

  onMenuItemLeave = (evt, index) => {
    const menuItem = evt.target.closest(".m-menu__item");
    // document.documentElement.classList.remove("prevent-scroll");

    clearTimeout(this.timeoutLeave);
    this.timeoutLeave = setTimeout(() => {
      if (menuItem && menuItem.matches(":hover")) return;

      this.activeIndex = -1;
      this.lastActiveIndex = index;
      menuItem && menuItem.classList.remove("m-menu__item--active");

      if (this.activeIndex === -1 || this.activeIndex < 0) {
        this.visited = false;
      }
      this.resetMegaMenu(evt.target);
    }, 250);
  };

  reInitSlider = (menuItem) => {
    const swiper = menuItem.querySelector(this.selectors.swiper);
    if (!swiper) return;
    const itemIndex = menuItem.dataset.index;
    const slider = MinimogTheme && MinimogTheme.headerSliders[itemIndex];
    slider && slider.update();
  };

  getElementBoundingRect = async (element) => {
    const subMenu = element.querySelector(this.selectors.subMenu);
    if (subMenu) {
      const rect = subMenu.getBoundingClientRect();
      return {
        width: rect.width,
        height: rect.height,
        left: rect.left,
        top: rect.top,
      };
    }
  };

  resetMegaMenu = () => {
    this.activeIndex = -1;

    clearTimeout(this.timeoutEnter);
    clearTimeout(this.timeoutLeave);
    this.container &&
      this.container.classList.remove(
        this.classes.active,
        this.classes.slideFromRight,
        this.classes.slideReveal,
        "sf-header--bg-black",
        "sf-header--bg-white"
      );
  };

  closeSiblingMegaMenus = (currentMenuItem) => {
    const activeElement = document.activeElement;

    this.domNodes.menuItems.forEach((menuItem) => {
      if (menuItem === currentMenuItem) return;

      menuItem.classList.remove("m-menu__item--active");
      const toggle = menuItem.querySelector(".m-menu__link--main[aria-expanded]");
      toggle && toggle.setAttribute("aria-expanded", "false");

      if (activeElement && menuItem.contains(activeElement)) {
        activeElement.blur();
      }
    });
  };

  closeOpenMegaMenu = () => {
    const activeElement = document.activeElement;

    this.domNodes.menuItems.forEach((menuItem) => {
      menuItem.classList.remove("m-menu__item--active");
      const toggle = menuItem.querySelector(".m-menu__link--main[aria-expanded]");
      toggle && toggle.setAttribute("aria-expanded", "false");
    });

    if (activeElement && this.container.contains(activeElement) && activeElement.closest(".m-menu__item")) {
      activeElement.blur();
    }

    this.visited = false;
    this.lastActiveIndex = -1;
    this.resetMegaMenu();
  };

  onWindowScroll = () => {
    const currentScroll = window.scrollY;

    if (currentScroll > this.lastScrollY) {
      this.closeOpenMegaMenu();
    }

    this.lastScrollY = currentScroll;
  };

  windowWidth = () => {
    return window.innerWidth;
  };
  windowHeight = () => {
    return window.innerHeight;
  };

  destroy = () => {
    this.domNodes.menuItems.forEach((menuItem, index) => {
      menuItem.removeEventListener("mouseenter", (evt) => this.onMenuItemEnter(evt, index));
      menuItem.removeEventListener("mouseleave", (evt) => this.onMenuItemLeave(evt, index));
    });
    window.removeEventListener("scroll", this.onWindowScroll);
  };
}
